import { NavLink } from "react-router-dom";

export function Header() {
  return (
    <header className="site-header">
      <div className="header-inner">
        <a href="/" className="logo">Giv<span>n</span></a>
        <nav className="nav">
          <NavLink to="/lootjes" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>
            Lootjes
          </NavLink>
          <NavLink to="/hoe-het-werkt" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>
            Hoe het werkt
          </NavLink>
          <NavLink to="/contact" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}>
            Contact
          </NavLink>
          <a href="/" className="nav-cta" style={{ textDecoration: "none" }}>+ Voeg iemand toe</a>
        </nav>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <a href="https://givn.to" className="logo">Giv<span>n</span></a>
          <p>Nooit meer een cadeau vergeten. Givn stuurt je een herinnering met de beste suggesties — gratis, altijd.</p>
        </div>
        <div className="footer-col">
          <h4>Product</h4>
          <NavLink to="/">Cadeauassistent</NavLink>
          <NavLink to="/lootjes">Lootjes trekken</NavLink>
          <NavLink to="/hoe-het-werkt">Hoe het werkt</NavLink>
        </div>
        <div className="footer-col">
          <h4>Contact</h4>
          <NavLink to="/contact">Contact</NavLink>
          <a href="mailto:hallo@givn.to">hallo@givn.to</a>
          <a href="https://instagram.com/givn.to" target="_blank" rel="noopener noreferrer">Instagram</a>
        </div>
        <div className="footer-col">
          <h4>Legal</h4>
          <NavLink to="/privacy">Privacybeleid</NavLink>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Givn — givn.to</span>
        <span>Gemaakt in Nederland 🌷</span>
      </div>
    </footer>
  );
}
